import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {
  DateInput,
  FormField,
  formatDateInput,
  parseDateInput,
} from 'wobi-web-common/dist/v2/index.js';

const DobField = ({value, onChange, error, errorMessage, label}) => {
  const intl = useIntl();
  const resolvedLabel = label || intl.formatMessage({id: 'step1.tab2.dob'});
  const [inputInvalid, setInputInvalid] = React.useState(false);
  const invalidDateMessage = intl.formatMessage({id: 'dobField.invalidFormat'});
  const resolvedError = value
    ? errorMessage || invalidDateMessage
    : intl.formatMessage({id: 'dobField.error'});
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const minDob = new Date(today);
  minDob.setFullYear(today.getFullYear() - 95);

  return (
    <FormField
      label={resolvedLabel}
      error={!inputInvalid && error ? resolvedError : undefined}
    >
      <DateInput
        value={value}
        onChange={onChange}
        onInvalidChange={setInputInvalid}
        minDate={minDob}
        maxDate={today}
        initialViewDate={today}
        yearOrder='descending'
        enableMonthSelection
        invalid={error || inputInvalid}
        invalidMessage={invalidDateMessage}
        calendarLabel={intl.formatMessage({id: 'dobField.selectDate'})}
        openCalendarLabel={intl.formatMessage({id: 'dobField.openCalendar'})}
        popupStrategy='viewport'
        locale='he-IL'
        className='traveler-dob-input'
        inputStyle={{direction: 'ltr', textAlign: 'right'}}
      />
    </FormField>
  );
};

DobField.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export {formatDateInput, parseDateInput};
export default DobField;
